export const UPDATE_PIPVALUE_FIELDS = 'UPDATE_PIPVALUE_FIELDS';

interface UpdatePipvalueFields {
  type: typeof UPDATE_PIPVALUE_FIELDS;
  payload: Partial<IPipvalueFields>;
}

export type PipvalueActionTypes = UpdatePipvalueFields;